export const notFound = {
  path: '/:pathMatch(.*)',
  name: 'notFound',
  meta: {
    title: '404',
    hidden: 1,
  },
  component: () => import('@/views/error/404.vue'),
  //redirect: defaultRoutePath
};
